import { Alert, Spinner } from '@arabat/ui';
import { InvoiceView, useApi } from '@arabat/web-core';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router';
import { useSlug } from '../shared.js';

/**
 * An order's invoice at the store's own address (ADR-0138 amendment 8), for anyone with the link:
 * print and PDF; the store's WhatsApp button adds `?for=store` for its actions (send to the
 * customer, share the PDF, call). The link the customer receives is this page without it.
 */
export function InvoicePage() {
  const { t } = useTranslation();
  const api = useApi();
  const slug = useSlug();
  const { token = '' } = useParams();
  const [params] = useSearchParams();
  const invoice = useQuery({
    queryKey: ['store', slug, 'invoice', token],
    queryFn: () => api.store.invoice(slug, token),
    retry: false,
  });
  if (invoice.isPending)
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  if (invoice.isError || !invoice.data)
    return (
      <main className="mx-auto max-w-md p-6">
        <Alert tone="warning" title={t('invoice.notFound')}>
          {t('invoice.notFoundHint')}
        </Alert>
      </main>
    );
  return (
    <InvoiceView
      invoice={invoice.data}
      customerUrl={`${window.location.origin}${window.location.pathname}`}
      forStore={params.get('for') === 'store'}
    />
  );
}
